import { FC } from 'react'
// @ts-ignore
import { CwsCarousel } from 'cms-web-styleguide'
import { ImagePageBanner } from '@api/content'
import Link from 'next/link'
import { CldImage } from 'next-cloudinary'
import { useMediaLess } from '@ui/hooks/useMediaLess'
import { CwsCarouselItem } from '@components/cws'

export interface BannersProps {
  banners: ImagePageBanner[]
}

export const Banners: FC<BannersProps> = ({ banners = [] }) => {
  const shouldAutoplay = banners.length > 1
  const isMobile = useMediaLess(600)
  return (
    <CwsCarousel mode={'hero'} autoplay={shouldAutoplay}>
      {banners.map((banner, idx) => {
        if (banner.clickUrl)
          return (
            <CwsCarouselItem key={banner.image} className="hover:opacity-90">
              <Link href={banner.clickUrl} passHref>
                <section style={{ width: '100%', aspectRatio: '1288 / 460', position: 'relative' }}>
                  <CldImage
                    layout="fill"
                    src={banner.image}
                    namedTransformations={isMobile ? ['m-banner'] : ['banner']}
                    alt={`image-banner-url-${idx}`}
                  />
                </section>
              </Link>
            </CwsCarouselItem>
          )
        return (
          <CwsCarouselItem key={banner.image}>
            <section style={{ width: '100%', aspectRatio: '1288 / 460', position: 'relative' }}>
              <CldImage
                layout="fill"
                src={banner.image}
                namedTransformations={isMobile ? ['m-banner'] : ['banner']}
                alt={`image-banner-url-${idx}`}
              />
            </section>
          </CwsCarouselItem>
        )
      })}
    </CwsCarousel>
  )
}
